import Vue from 'vue'
import $ from 'jquery'

// Add this to make $ available in all components
Vue.prototype.$ = $

import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false

import myfun from './assets/myfun'
Vue.prototype.myfun = myfun

import i18n from './i18n/';


import '../public/bootstrap/js/bootstrap.min.js'
import '../public/bootstrap/css/bootstrap.min.css'

import '../public/bootstrap-table/bootstrap-table'
import '../public/bootstrap-table/bootstrap-table.css'

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
